import React, { createContext, useContext, useEffect, useState } from "react";
import api from "./api";
import { IMG as DEFAULTS } from "../components/brand";

const Ctx = createContext({ images: DEFAULTS, reload: () => {} });

export function ImagesProvider({ children }) {
  const [images, setImages] = useState(DEFAULTS);

  const load = async () => {
    try {
      const { data } = await api.get("/public/site-images");
      // overrides (data URL strings) take precedence; unset keys keep defaults
      setImages({ ...DEFAULTS, ...data });
    } catch (e) { console.warn("[images] load failed, using defaults:", e); }
  };

  useEffect(() => { load(); }, []);

  return <Ctx.Provider value={{ images, reload: load }}>{children}</Ctx.Provider>;
}

export const useImages = () => useContext(Ctx);
